import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { MediaStatusType } from '@stores/UploadURL/mediaStatus';
import { useUploadURL } from '@stores/UploadURL/UploadURLStore';
import { observer } from 'mobx-react-lite';
import css from './MediaDataGrid.module.scss';

export type HeaderMessageType = 'error' | 'warning' | 'in-library';

export interface HeaderMessage {
  id: string;
  type: HeaderMessageType;
  text: string;
}

const typeClassMap: Record<HeaderMessageType, string> = {
  error: css.headerStatusChipError,
  warning: css.headerStatusChipWarning,
  'in-library': css.headerStatusChipInLibrary,
};

interface HeaderStatusMessagesProps {
  messages: HeaderMessage[];
  onDismiss: () => void;
  onShowAll: () => void;
}

export const HeaderStatusMessages = observer(
  ({ messages, onDismiss, onShowAll }: HeaderStatusMessagesProps) => {
    const store = useUploadURL();

    if (messages.length === 0) return null;

    const handleClick = (type: MediaStatusType) => {
      store.toggleStatusFilter(type);
    };

    return (
      <div className={css.headerStatusRow}>
        {messages.map((msg) => {
          const isActive = store.activeStatusFilters.has(msg.type);
          const classes = [
            css.headerStatusChip,
            typeClassMap[msg.type],
            isActive ? css.headerStatusChipActive : '',
          ]
            .filter(Boolean)
            .join(' ');

          return (
            <button key={msg.id} className={classes} onClick={() => handleClick(msg.type)}>
              {msg.text}
            </button>
          );
        })}
        <button className={css.headerStatusShowAll} onClick={onShowAll}>
          Show all
        </button>
        <IconButton className={css.headerStatusClose} onClick={onDismiss} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    );
  },
);

HeaderStatusMessages.displayName = 'HeaderStatusMessages';
